import { InputText } from "primereact/inputtext";
import { useIntl } from "react-intl";
import "./InputSearch.css";

const InputSearch = (props: any) => {
  const intl = useIntl();

  return (
    <>
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          onChange={(e: any) => props.onInputChange(e.target.value)}
          placeholder={intl.formatMessage({
            id: "input-search-placeholder",
          })}
          className="input-search-container"
        />
      </span>
    </>
  );
};

export default InputSearch;
